/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 21st 2023, 11:23:03 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { IntegrationCredentialStore } from "lib/schemas";
import { Image } from "ui-widgets";

interface CredentialStoreCardProps {
  storeName: IntegrationCredentialStore["name"];
  actions: React.ReactNode;
}

export const CredentialStoreCard = ({ storeName, actions }: CredentialStoreCardProps) => {
  return (
    <Stack
      direction="row"
      sx={{ border: "1px solid #e0e0e0", padding: "10px 10px 10px 10px", borderRadius: "12px" }}
      spacing={2}
    >
      <Image src={"/img/authentication.png"} alt="Onestop Admin" width="80px" height="80px" />
      <Stack>
        <h4>{storeName}</h4>
        <Stack direction="row" spacing={4}>
          {actions}
        </Stack>
      </Stack>
    </Stack>
  );
};
